import type { Screen } from '../types';

export interface NavSubItem {
  id: string;
  label: string;
  icon: string;
  screen: Screen;
  tab?: 'collaterals' | 'playbooks'; // for Library sub-items
  badge?: string;
  badgeRed?: boolean;
  badgeGreen?: boolean;
}

export interface NavItem {
  id: string;
  label: string;
  icon: string;
  screen?: Screen;                   // if it navigates directly
  badge?: string;
  badgeRed?: boolean;
  badgeGreen?: boolean;
  badgeText?: string;                // special text badge e.g. "1 live"
  collapsible?: boolean;
  children?: NavSubItem[];
}

export interface NavGroup {
  group?: string;                    // section header label
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    items: [
      { id: 'home', label: 'Home', icon: 'ti-home-2', screen: 'home', badge: '3' },
    ],
  },
  {
    group: 'LIBRARY',
    items: [
      {
        id: 'library', label: 'Library', icon: 'ti-layout-grid', collapsible: true,
        children: [
          { id: 'collaterals', label: 'Collaterals', icon: 'ti-files',  screen: 'admin', tab: 'collaterals' },
          { id: 'playbooks',   label: 'Playbooks',   icon: 'ti-book-2', screen: 'admin', tab: 'playbooks', badge: '5' },
        ],
      },
    ],
  },
  {
    group: 'DEALS',
    items: [
      { id: 'leads',     label: 'Leads',         icon: 'ti-user-bolt',  screen: 'leads',     badgeText: '1 live', badgeGreen: true },
      { id: 'dealrooms', label: 'Deal Room',      icon: 'ti-building',   screen: 'dealrooms' },
      {
        id: 'demohub', label: 'Demo Hub', icon: 'ti-presentation-analytics', screen: 'demohub', collapsible: true,
        children: [
          { id: 'demohub-tours', label: 'Product Tours', icon: 'ti-player-play',  screen: 'demohub' },
          { id: 'demohub-sales', label: 'Sales Demos',   icon: 'ti-send',         screen: 'demohub' },
        ],
      },
    ],
  },
  {
    group: 'ANALYTICS',
    items: [
      { id: 'analytics', label: 'Analytics',    icon: 'ti-chart-bar',  screen: 'analytics' },
      { id: 'tracking',  label: 'Live Tracking', icon: 'ti-broadcast',  screen: 'tracking',  badge: '2' },
      { id: 'nudges',    label: 'Smart Nudges',  icon: 'ti-bell-ringing', screen: 'home',    badge: '3' },
    ],
  },
  {
    items: [
      { id: 'client', label: 'Buyer View',     icon: 'ti-eye',   screen: 'client' },
      { id: 'team',   label: 'Team & Modules', icon: 'ti-users', screen: 'team'   },
    ],
  },
];

// Flat list for bottom mobile tab bar
export const MOBILE_TABS = [
  { id: 'home',      label: 'Home',      icon: 'ti-home-2',     screen: 'home'      as Screen },
  { id: 'leads',     label: 'Leads',     icon: 'ti-user-bolt',  screen: 'leads'     as Screen, badge: '6', badgeRed: true },
  { id: 'admin',     label: 'Library',   icon: 'ti-files',      screen: 'admin'     as Screen },
  { id: 'analytics', label: 'Analytics', icon: 'ti-chart-bar',  screen: 'analytics' as Screen },
  { id: 'more',      label: 'More',      icon: 'ti-dots',       screen: undefined              },
];
